import { useEffect, useState } from "react"
import { IJobsheet } from "../../../../../../interfaces/jobsheets/IJobsheet"
import * as webHelpers from "../../../../../../helpers/WebHelpers";
import { IPoison, IPoisonLine, IPoisonMeasurement } from "../../../../../../interfaces/jobsheets/IPoison";
import { Box, Button, Card, Flex, Heading, HStack, Spacer, Text, VStack, Wrap, WrapItem } from "@chakra-ui/react";
import { IWipLine } from "../../../../../../interfaces/jobsheets/IWipline";
import { ICoshhEntry } from "../../../../../../interfaces/jobsheets/ICoshh";
import { BiDownload } from "react-icons/bi"
import { GrDocumentPdf } from "react-icons/gr";

interface IProps {
    jobNumber: string,
}

interface IComplianceRecords {
    poisons: IComplianceRecord[],
    coshh: IComplianceRecord[]
}

interface IComplianceRecord {
    id: string,
    poison_id: string,
    wip_line_id: string,
    name: string,
    measurement: IPoisonMeasurement,
    quantity: number,
    location: string,
    notes: string,
    document_id: string
}

export const PoisonCoshhSummary = (props: IProps) => {
    const [records, setRecords] = useState<IComplianceRecord[]>([]);
    
    useEffect(() => {
        GetRecords(props.jobNumber).then(res => {
            if (res != null){
                setRecords(res.poisons);
            }
        });
    }, []);

    const GetRecords = async (jobNumber: string) => {
        return await webHelpers.getAsync<IComplianceRecords>("/api/archive/document/all?jobNumber=" + jobNumber);
    }

    const GetPoison = async (id: string) => {
        return await webHelpers.getAsync<IPoison>("/api/sales/products/poison/get?id=" + id);
    }

    const GetCoshh = async (id: string) => {
        return await webHelpers.getAsync<ICoshhEntry>("/api/sales/products/coshh/get?id=" + id);
    }

    const onDownloadFile = async (id: string) => {
        let response: Response = await webHelpers.getAsStreamAsync("/api/archive/document/get?id=" + id);
        let disposition: string | null = response.headers.get('content-disposition');
        let type: string | null = response.headers.get('content-type');
        let fileName = disposition?.split("filename=")[1];
        fileName = fileName?.substring(1, fileName.length - 1);

        if (type !== null){
            const file = new Blob([await response.blob()], {type: type});
            const fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.download = fileName ?? "Test";

            fileLink.click();
        }
    }

    if (records.length < 1) return <></>

    return (
        <Box borderWidth='1px' borderColor='gray.400' borderRadius='lg' h='full'>
            <Flex direction='column' w='full' h='max'>
                <Heading size='md' color='var(--Able-blue)' borderBottom='2px' borderColor='gray.200' m={2} p={2}>Treatment Details</Heading>
                <Text px={4}>Information about the products that have been used are shown below. You may also download the assoicated safety information.</Text>
                <Wrap justifyItems='start' w='full' p={2}>
                    {records.map((p: IComplianceRecord) => 
                        <WrapItem>
                            <Box>
                                <VStack align='left' spacing={1} m={2}>
                                    <Flex>
                                        <Text as='b'>{p.quantity}</Text>
                                        {p.measurement.abbreviation === null ? 
                                            <Text as='b'>{p.quantity > 1 ? p.measurement.plural_name : p.measurement.name}</Text>
                                            :
                                            <Text as='b'>{p.measurement.abbreviation}</Text>
                                        }
                                        <Text ml={2}> {p.name}</Text>
                                    </Flex>
                                    <Text><b>Location: </b>{p.location}</Text>
                                    <Text><b>Notes: </b>{p.notes}</Text>
                                    <div className='screen-only'>
                                        <Button onClick={() => onDownloadFile(p.document_id)} leftIcon={<BiDownload/>} color={"var(--Able-blue)"}>Safety Infomation</Button>
                                    </div>
                                </VStack>
                            </Box>
                        </WrapItem>
                    )}
                </Wrap>
            </Flex>
        </Box>
    )
}